var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Card from "../Components/Card.vue";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
import PostalAddress from "../Components/PostalAddress.vue";
import RoomNumber from "../Components/RoomNumber.vue";
import Coordinators from "../Components/Coordinators.vue";
import Calendar from "../Components/Calendar.vue";
import CalendarEvent from "../Components/CalendarEvent.vue";
var Schedule = /** @class */ (function (_super) {
    __extends(Schedule, _super);
    function Schedule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Schedule.prototype.sortSchedule = function (sessions) {
        if (!sessions)
            return [];
        return sessions
            .sort(function (l, r) { return l.start.valueOf() - r.start.valueOf(); });
    };
    Schedule.prototype.isFirstOfDay = function (sessions, index) {
        if (index <= 0)
            return true;
        return !sessions[index].start.isSame(sessions[index - 1].start, "day");
    };
    Object.defineProperty(Schedule.prototype, "events", {
        get: function () {
            return [this.sessions, this.extraCurricular]
                .flatten(function (p) { return p.children; })
                .map(function (session) { return session.schedule.map(function (schedule) {
                return __assign({ id: session.id }, schedule, { general: session.general });
            }); })
                .flatten(function (p) { return p; });
        },
        enumerable: true,
        configurable: true
    });
    Schedule.prototype.onCalendarClicked = function (event) {
        var card = this.$refs.cards
            .filter(function (p) { return p.$attrs["session-id"] === event.id; })
            .map(function (p) { return p.$el; })[0];
        if (!card)
            return;
        card.scrollIntoView(false); // align bottom so we don't have to deal with locked header offset
    };
    __decorate([
        Prop({ type: String, default: "dddd" })
    ], Schedule.prototype, "dayFormat", void 0);
    __decorate([
        Prop({ type: String, default: "LT" })
    ], Schedule.prototype, "timeFormat", void 0);
    __decorate([
        Prop({ type: Object })
    ], Schedule.prototype, "sessions", void 0);
    __decorate([
        Prop({ type: Object })
    ], Schedule.prototype, "extraCurricular", void 0);
    Schedule = __decorate([
        Component({
            name: "Schedule",
            components: {
                Card: Card,
                PostalAddress: PostalAddress,
                RoomNumber: RoomNumber,
                Coordinators: Coordinators,
                Calendar: Calendar,
                CalendarEvent: CalendarEvent,
                "b-row": Row,
                "b-col": Col
            }
        })
    ], Schedule);
    return Schedule;
}(Vue));
export default Schedule;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Colloquium/Schedule.vue
// module id = 892
// module chunks = 0